import { useRef, useState, useEffect } from "react";
import { motion, useInView } from "framer-motion";

export default function RevealImage({ src, alt, className = "", aspectRatio = "aspect-[4/3]" }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (isMobile) {
    // On mobile: always visible, gentle fade-in on scroll
    return (
      <div
        ref={ref}
        className={`overflow-hidden ${aspectRatio} ${className}`}
        data-testid="reveal-image-mobile"
      >
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className={`group overflow-hidden ${aspectRatio} cursor-pointer ${className}`}
      data-testid="reveal-image-desktop"
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover transition-all duration-500 ease-out group-hover:scale-[1.04] group-hover:brightness-110 group-hover:shadow-lg"
      />
    </div>
  );
}
